function setupClickHandlers() {
  const variantButtons = document.querySelectorAll(".variant_button");
  if (variantButtons.length > 0) {
    variantButtons.forEach(function(element) {
      element.addEventListener('click', function(event) {
        event.preventDefault();
        handleElementClick(this);
      });
    });
  }

  const popupElement = document.querySelector('.popup');
  if (popupElement) {
    popupElement.addEventListener('click', function(event) {
      if (event.target.classList.contains('popup') || event.target.closest('.close-button')) {
        closePopup();
      }
    });
  }
}

function handleElementClick(element) {
  const url = element.getAttribute('data-url');
  const popup = document.querySelector(".popup");
  const ticketPopup = document.querySelector('#ticket-popup');

  if (!popup || !ticketPopup) {
    console.error("Popup or ticket-popup element not found.");
    return;
  }

  popup.classList.add('model-open');
  document.body.classList.add('overflowHidden');

  const fullUrl = `${location.origin}${url}&sections=book-ticket-popup`;
  console.log(fullUrl);

  ticketPopup.innerHTML = '';
  fetch(fullUrl)
    .then(response => response.json())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText['book-ticket-popup'], 'text/html');
      const newTicketPopupContent = html.querySelector('#ticket-popup');

      if (newTicketPopupContent) {
        ticketPopup.innerHTML = newTicketPopupContent.innerHTML;
        
        const continueButton = document.getElementById('continue_button-popup');
        if (continueButton) {
          continueButton.addEventListener('click', function() {
            const productId = this.getAttribute('data-id');
            const quantity = document.querySelector('#Quantity-book-ticket-popup').value;
          });
        }
      }
    })
    .catch((e) => {
      console.error(e);
    });
}


function closePopup() {
  document.querySelector('.popup').classList.remove('model-open');
  document.body.classList.remove('overflowHidden');
}
setupClickHandlers();







